export var DocumentTypesCode;
(function (DocumentTypesCode) {
    DocumentTypesCode["CNPJ"] = "CNPJ";
    DocumentTypesCode["CPF"] = "CPF";
    DocumentTypesCode["SSN"] = "SSN";
    DocumentTypesCode["EIN"] = "EIN";
    DocumentTypesCode["Email"] = "Email";
    DocumentTypesCode["Hash"] = "Hash";
    DocumentTypesCode["Document"] = "Document";
})(DocumentTypesCode || (DocumentTypesCode = {}));
